import invoice from '@/api/invoice'
import preInvoice from '@/api/pre-invoice'
import feeType from '@/api/fee-type'
import feeGroup from '@/api/fee-group'
import creditDay from '@/api/default-credit-day'
import vehicle from '@/api/vehicle-profile'
import promotion from '@/api/promotion'
import mainProgram from '@/api/main-program'
import subProgram from '@/api/sub-program'
import moment from 'moment'
import { join } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  defaultCreditDay: 0,
  room_type_id: null,
  branch_id: null,
  showData: {},
  feeSetups: [],
  mainPrograms: [],
  acp_id: null,
  acps_id: [],
  paymentTerms: [],
  promotionRate: [],
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  is_deleted: 0,
  created_by: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SHOW_DATA(state, data) {
    state.showData = data
  },
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_DEFAULT_CREDIT_DAY(state, numberDay) {
    state.defaultCreditDay = numberDay
  },
  SET_ROOM_TYPE_ID(state, id) {
    state.room_type_id = id
  },
  SET_MAIN_PROGRAM(state, data) {
    state.mainPrograms = data
  },
  SET_APC_ID(state, data) {
    state.acp_id = data
  },
  SET_APCS_ID(state, data) {
    state.acps_id = data
  },
  SET_PAYMENT_TERMS(state, data) {
    state.paymentTerms = data
  },
  SET_IS_DELETE(state, data) {
    state.is_deleted = data
  },
  SET_PROMOTION_VALUE(state, promotionRate) {
    if (promotionRate.length > 0) {
      state.promotionRate = promotionRate[0]
    }
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_CREATED_BY(state, data) {
    state.created_by = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          is_deleted: context.state.is_deleted | 0,
          acp_id: context.state.acp_id,
          acps_id: join(context.state.acps_id, ','),
          created_by: join(context.state.created_by, ',')
        }
      },
      attrubutes
    )
    return invoice.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async find(context, id) {
    if (_.isEmpty(context.state.showData)) {
      let response = await invoice.find(id)
      context.commit('SET_SHOW_DATA', response.data)
    }
  },
  store(context, data) {
    return invoice.store(data)
  },
  destroy(context, { id, data }) {
    return invoice.destroy(id, data)
  },
  getFeeType(context, attrubutes = {}) {
    return feeType.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getStudent(context, attrubutes = {}) {
    return invoice.getStudent({
      params: attrubutes
    })
  },
  getPreInvoice(context, attrubutes = {}) {
    return preInvoice.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getFeeGroup(context, grade_id) {
    return feeGroup.listQuery(grade_id)
  },
  getLatestInvoice(context, studentId) {
    return invoice.latestInvoiceStudent(studentId)
  },
  async getDefaultCreditDay(context, attrubutes = {}) {
    if (!context.state.defaultCreditDay > 0) {
      let response = await creditDay.get({
        params: attrubutes,
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      if (response.data.length > 0) {
        context.commit('SET_DEFAULT_CREDIT_DAY', response.data[0].credit_day)
      }
    }
  },
  getSubscriptionService(context, data) {
    return invoice.studentSubscript(data)
  },
  getFeeSetupDetail(context, data) {
    return invoice.getFeeSetupWithDetail(data)
  },
  feeGroupDetail(context, data) {
    return invoice.feeGroupDetail(data)
  },
  registerVehicel(context, studentId) {
    return invoice.checkStudentRegisterVehicel(studentId)
  },
  getVehicleOperation(context, attrubutes = {}) {
    return vehicle.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  previewPdf(context, id) {
    return invoice.printPDF(id)
  },
  getPromotion(context, { condition }) {
    return promotion
      .get({
        params: {
          fields: {
            academic_program_sub_promotions:
              'promotion_rate,promotion_expiry_date'
          },
          filter: {
            acps_id: condition.acps_id,
            ac_term_id: condition.ac_term_id,
            where_expired_date: moment().format('YYYY-MM-DD')
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_PROMOTION_VALUE', response.data)
        return Promise.resolve(response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  getMainProgram(context) {
    return mainProgram
      .get({
        params: {
          fields: {
            academic_program_mains: 'acp_id,acp_name_foreign'
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_MAIN_PROGRAM', response.data)
        return Promise.resolve(response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  fetchSubProgram(context, attributes = {}) {
    return subProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          filter: {
            acp_id: attributes.acp_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  eligable(context, data) {
    return invoice.eligable(data)
  },
  getPaymentTerm(context, attrubutes = {}) {
    return invoice
      .getPaymentTerm({
        params: attrubutes,
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_PAYMENT_TERMS', response.data)
        return Promise.resolve(response)
      })
  },
  createNewStudent(context, data) {
    return invoice.createNewStudent(data)
  },
  bankStudent(context, studentId) {
    return invoice.bankStudent(studentId)
  },
  getClassId(context, payload) {
    return invoice.getClassId(payload)
  },
  checkIsDuplicateFeeType(context, data) {
    return invoice.checkIsDuplicateFeeType(data)
  },
  getExchangeRate(context, data) {
    return invoice.exchangeRate(data)
  },
  invoiceFormView(context, params = {}) {
    return invoice.invoiceFormViewModel({ params })
  }
}
